import React from 'react';

import {
  AutocompleteArrayInput,
  ReferenceArrayInput,
  ReferenceArrayInputProps,
} from 'react-admin';

const AutocompleteUserArrayInput: React.FC<
  Omit<ReferenceArrayInputProps, 'reference' | 'filterToQuery'>
> = ({ source, filter, ...props }) => (
  <ReferenceArrayInput
    {...props}
    source={source}
    filter={filter}
    reference="User"
  >
    <AutocompleteArrayInput
      optionText="email"
      filter="email"
      clearOnBlur={false}
      fullWidth
      filterToQuery={(email: string) => ({ email })}
    />
  </ReferenceArrayInput>
);

export default AutocompleteUserArrayInput;
